if (!customElements.get('swap-media')) {
    customElements.define(
      'swap-media',
      class SwapMedia extends HTMLElement {
        constructor() {
          super();
          this.swapTrigger = this.querySelector('.media-swap__button');
          this.mainImageContainer = this.querySelector('.media-swap__main-image');
          this.swapImageWrapper = this.querySelector('.swap-image-wrapper');
          
          // Read the value from data-current-media attribute
          const mediaFromAttribute = this.mainImageContainer?.getAttribute('data-current-media');

          // Fallback to 'editorial' if not set
          this.currentMedia = mediaFromAttribute === 'product' ? 'product' : 'editorial';

          this.bindEvents();
          this.setInitialVisibility();
        }
  
        bindEvents() {
          this.swapTrigger.addEventListener('click', this.onButtonClick.bind(this));
        }
  
        setInitialVisibility() {
          this.toggleVisibility(this.currentMedia);
        }
  
        toggleVisibility(typeToShow) {
          const typeToHide = typeToShow === 'editorial' ? 'product' : 'editorial';
  
          const showInMain = this.mainImageContainer.querySelector(`[data-media="${typeToShow}"]`);
          const hideInMain = this.mainImageContainer.querySelector(`[data-media="${typeToHide}"]`);
  
          const showInButton = this.swapImageWrapper.querySelector(`[data-media="${typeToShow}"]`);
          const hideInButton = this.swapImageWrapper.querySelector(`[data-media="${typeToHide}"]`);
  
          // Add or remove `is-visible` class
          showInMain?.classList.add('is-visible');
          hideInMain?.classList.remove('is-visible');
  
          showInButton?.classList.add('is-visible');
          hideInButton?.classList.remove('is-visible');
        }
  
        onButtonClick(event) {
          event.preventDefault();
  
          // Toggle between 'editorial' and 'product'
          this.currentMedia = this.currentMedia === 'editorial' ? 'product' : 'editorial';
          this.toggleVisibility(this.currentMedia);
        }
      }
    );
  }